<template>
  <google-map-wrapper>
    <template #default="{ googleApi }">
      <google-heat-map
        v-if="heatMapData"
        :center="center"
        :zoom="$options.initialZoom"
        :heatMapData="heatMapData"
        :google="googleApi"
        :options="$options.googleMapOptions"
        :map-type-id="$options.mapType"
        :needBound="needBound"
        @map-promise="mapPromise"
        @zoom-changed="zoomChanged"
      />
    </template>
  </google-map-wrapper>
</template>

<script>
import styles from '@utils/mapStylesDark.js'

import GoogleHeatMap from '../googleMaps/GoogleHeatMap.vue'
import GoogleMapWrapper from '../googleMaps/GoogleMapWrapper.vue'

const googleMapOptions = {
  mapTypeControl: false,
  streetViewControl: false,
  styles,
  zoomControl: false,
  fullscreenControl: true,
  gestureHandling: 'cooperative'
}
const mapType = 'terrain'
const initialZoom = 3

function normalizeHeatMapPoint(point) {
  if (Array.isArray(point)) {
    return point
  }

  if (!point || typeof point !== 'object') {
    return null
  }

  if (Array.isArray(point.coordinates) && !Array.isArray(point.coordinates[0])) {
    return [
      point.coordinates[0],
      point.coordinates[1],
      point.weight !== undefined
        ? point.weight
        : (point.coordinates[2] !== undefined ? point.coordinates[2] : 1)
    ]
  }

  const lng = point.lng !== undefined ? point.lng : (point.lon !== undefined ? point.lon : point.longitude)
  const lat = point.lat !== undefined ? point.lat : point.latitude

  if (lng === undefined || lat === undefined) {
    return null
  }

  return [
    lng,
    lat,
    point.weight !== undefined ? point.weight : (point.count !== undefined ? point.count : 1)
  ]
}

function normalizeHeatMapPoints(points) {
  if (Array.isArray(points)) {
    return points.map(normalizeHeatMapPoint).filter(point => point !== null)
  }

  if (!points || typeof points !== 'object') {
    return []
  }

  if (points.coordinates !== undefined) {
    const coordinatePoint = normalizeHeatMapPoint(points)

    if (coordinatePoint) {
      return [coordinatePoint]
    }

    return normalizeHeatMapPoints(points.coordinates)
  }

  if (points.points !== undefined) {
    return normalizeHeatMapPoints(points.points)
  }

  const singlePoint = normalizeHeatMapPoint(points)

  if (singlePoint) {
    return [singlePoint]
  }

  return normalizeHeatMapPoints(Object.values(points))
}

export default {
  name: 'Heatmap',
  components: { GoogleHeatMap, GoogleMapWrapper },
  googleMapOptions,
  mapType,
  initialZoom,
  props: {
    initialPoints: {
      type: [Array, Object],
      default: () => []
    },
    center: {
      type: Object,
      default: () => {
        return { lat: 0, lng: 0 }
      }
    },
    needBound: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      heatMapData: normalizeHeatMapPoints(this.initialPoints)
    }
  },
  watch: {
    initialPoints(points) {
      this.heatMapData = normalizeHeatMapPoints(points)
    }
  },
  methods: {
    mapPromise(map) {
      this.$emit('map-promise', map);
    },

    zoomChanged(zoom){
      this.$emit('zoom-changed', zoom)
    },
  }
}
</script>
